module.exports = __webpack_public_path__ + "img/xtools.4a21945e.png";